import { reactive } from 'vue';

// Servis.js'in axios interceptor'ı ile App.vue'daki tam ekran overlay arasında paylaşılan
// hafif reaktif bağlantı durumu — uiState.js (nav loading) ile aynı desen.
//
// kesikMi=true iken kullanıcı hiçbir şey yapamaz (tam ekran engelleyici gösterilir).
// Bağlantı dönünce: kesinti anında bekleyen bir KAYDET/SIL isteği varsa (yaziKaybiRiski)
// sessizce devam edilmez — kullanıcı açıkça uyarılır (uyariGoster). Yoksa (salt okuma/boşta)
// overlay kapanır, kullanıcı sessizce devam eder.
export const baglantiState = reactive({
  kesikMi: false,
  uyariGoster: false,
  baslangic: null,
});

let pingTimer = null;
// Anda bekleyen yazma (POST/PUT/DELETE) istek sayısı — Servis.js her istek başlarken/bitirirken günceller.
let yazmaSayaci = 0;

export function yazmaBasladi() {
  yazmaSayaci++;
}
export function yazmaBitti() {
  if (yazmaSayaci > 0) yazmaSayaci--;
}

function pingUrl() {
  return process.env.NODE_ENV === 'production'
    ? 'https://api.hepy.app/api/Ping'
    : 'https://localhost:44386/api/Ping';
}

function pingDene() {
  return fetch(pingUrl(), { method: 'GET', cache: 'no-store', credentials: 'omit' })
    .then((r) => r.ok)
    .catch(() => false);
}

export function baglantiKesildi() {
  // Zaten kesikken araya giren ayrı bir yazma isteği de kaybolduysa riski işaretle,
  // ilk kesinti anını (baslangic) ezme.
  if (baglantiState.kesikMi) {
    return;
  }
  baglantiState.kesikMi = true;
  baglantiState.baslangic = Date.now();
  baglantiDongusuBaslat();
}

function baglantiDongusuBaslat() {
  if (pingTimer) return;
  pingTimer = setInterval(() => {
    pingDene().then((ok) => {
      if (ok) baglantiKurtarildi();
    });
  }, 4000);
}

function baglantiKurtarildi() {
  if (pingTimer) {
    clearInterval(pingTimer);
    pingTimer = null;
  }
  const sureSaniye = baglantiState.baslangic ? Math.round((Date.now() - baglantiState.baslangic) / 1000) : 0;
  const yaziKaybiRiski = yazmaSayaci > 0;
  const sayfa = window.location.pathname;

  baglantiState.kesikMi = false;
  baglantiState.baslangic = null;
  baglantiState.uyariGoster = yaziKaybiRiski;

  // Log çağrısı sunucuya ulaşınca yapılır (kesinti sırasında zaten mümkün değildi) — başarısız
  // olsa da kullanıcıyı etkilemesin.
  try {
    if (window.__Servis) {
      window.__Servis('POST', 'LogBaglantiKesintisi', {
        SureSaniye: sureSaniye,
        Sayfa: sayfa,
        YaziKaybiRiski: yaziKaybiRiski,
      }).catch(() => {});
    }
  } catch (e) { /* yoksay */ }
}
